import { ZnglyVideoMediaNameEnum, ZnglyVideoPostTypeEnum } from '@/graphql/types';
import type { AppStore } from '@/inertia/AppStore';
import { useDefaultHandler } from './defaultIframe';
import { useMixcloudHandler } from './mixcloud';
import { useSoundCloudHandler } from './soundcloud';
import { useSpotifyHandler } from './spotify';
import { useVimeoHandler } from './vimeo';
import { useYoutubeHandler } from './youtube';

type Props = {
  node: AppStore['playerNode'];
};

export const useIframeMediaHandler = ({ node }: Props) => {
  if (node?.znglyContent?.contentMediaType !== ZnglyVideoPostTypeEnum.Embed) {
    return {};
  }

  switch (node?.znglyContent?.contentMediaName) {
    case ZnglyVideoMediaNameEnum.Youtube:
      return useYoutubeHandler({ eventName: 'zngly_media_youtube' });
    case ZnglyVideoMediaNameEnum.Spotify:
      return useSpotifyHandler({ eventName: 'zngly_media_spotify' });
    case ZnglyVideoMediaNameEnum.Mixcloud:
      return useMixcloudHandler({ eventName: 'zngly_media_mixcloud' });
    case ZnglyVideoMediaNameEnum.Soundcloud:
      return useSoundCloudHandler({ eventName: 'zngly_media_soundcloud' });
    case ZnglyVideoMediaNameEnum.Vimeo:
      return useVimeoHandler({ eventName: 'zngly_media_vimeo' });
    case ZnglyVideoMediaNameEnum.Pdf:
      return useDefaultHandler({ eventName: 'zngly_media_pdf' });
    default:
      return useDefaultHandler({ eventName: 'zngly_media_default_iframe' });
  }
};
